import type { SlugNode } from '@/lib/slug-rewrites';

export const routeName = 'partner-ngos';
export const slugs: Record<string, string> = {
	es: 'ong-colaboradoras',
	en: 'partner-ngos',
	ca: 'ong-collaboradores',
	fr: 'ong-partenaires',
	it: 'ong-partner',
};
/**
 * Empty, not absent: it opens `hasChildSegments`' depth gate, without which `/ong-colaboradoras/<id>`
 * would 404, and naming no segment leaves the NGO id untranslated both ways.
 */
export const children: Record<string, SlugNode> = {};

export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2026-08-24' };
